/* eslint-disable */

import React from 'react';
import { Card, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import ChartBarIcon from 'mdi-react/ChartBarIcon';
import FileDocumentOutlineIcon from 'mdi-react/FileDocumentOutlineIcon';
import ShieldAlertOutlineIcon from 'mdi-react/ShieldAlertOutlineIcon';
import ClipboardCheckOutlineIcon from 'mdi-react/ClipboardCheckOutlineIcon';

const METRIC_ICONS = {
  requests: ChartBarIcon,
  reader: FileDocumentOutlineIcon,
  censored: ShieldAlertOutlineIcon,
  analyzed: ClipboardCheckOutlineIcon
};

const CountRequestType = ({ title, value, metricId }) => {
  const Icon = METRIC_ICONS[metricId] || ChartBarIcon;
  const formattedValue = new Intl.NumberFormat('pt-BR', {
    maximumFractionDigits: 0
  }).format(Number(value));

  return (
    <Card className="count-request__metric-card card--not-full-height">
      <CardBody className="count-request__metric-card-body">
        <div className="count-request__metric-top">
          <div className="count-request__metric-icon-wrap" aria-hidden="true">
            <Icon className="count-request__metric-icon" />
          </div>
          <div className="count-request__metric-text">
            <p className="count-request__metric-value">{formattedValue}</p>
            <p className="count-request__metric-label">{title}</p>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

CountRequestType.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  metricId: PropTypes.oneOf(['requests', 'reader', 'censored', 'analyzed'])
    .isRequired
};

export default CountRequestType;
